module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "copyright"
  }, [_c('p', {
    staticClass: "extract"
  }, [_vm._v("© 2011 Michael Conly")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced in any form or by any electronic or mechanical means, including information storage and retrieval systems, without permission in writing from the publisher, except by a reviewer who may quote brief passages in a review.")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_vm._v("The characters and events in this book are fictitious. Any similarity to real persons, living or dead, is coincidental and not intended by the author.")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_vm._v("The Secret of Peillon")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("A Novel")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_vm._v("The Small Press")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("A Division of Brown Books Publishing Group")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("16250 Knoll Trail Drive, Suite 205")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Dallas, Texas75248")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    attrs: {
      "href": "http://www.BBSmallPress.com",
      "target": "_blank"
    }
  }, [_vm._v("www.BBSmallPress.com")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("(972) 381-0009")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_vm._v("eISBN978-1-612547-72-5")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("10 9 8 7 6 5 4 3 2 1")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_vm._v("For more information, please email the author at "), _c('a', {
    attrs: {
      "href": "mailto:ConlyConcepts@gmail.com"
    }
  }, [_vm._v("ConlyConcepts@gmail.com")]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ff3e4d72","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/copy.vue
// module id = 60
// module chunks = 0